import { shouldPublish } from "src/utils/publishUtils";
import { entertainmentCategoryMatchesRoute } from "src/utils/entertainmentCategory";

/**
 * Filters entertainment hub cards by publish window and optional category route slug.
 *
 * @param {import('src/utils/mapEntertainment').EntertainmentCard[]} cards
 * @param {string} [routeCategory] - `params.category` from react-router (EN or FR URL segment)
 * @param {{ livePreviewName?: string }} [options]
 * @returns {import('src/utils/mapEntertainment').EntertainmentCard[]}
 */
export function filterEntertainmentCards(cards, routeCategory, options = {}) {
  const { livePreviewName } = options;
  if (!Array.isArray(cards)) return [];

  return cards.filter((card) => {
    const isLiveCard = livePreviewName && card.name === livePreviewName;
    if (!isLiveCard && !shouldPublish(card)) return false;

    if (routeCategory) {
      return entertainmentCategoryMatchesRoute(routeCategory, card.category);
    }

    return true;
  });
}
